const passWord = {
  // 登录中手机验证码修改密码-极验
  ByPhoneLogin: '/userApi/v4/PassWord/changeByPhoneLogin',
  // ByPhoneLogin: '/userApi/v3/PassWord/changeByPhoneLogin',
  //  ByPhoneLogin: '/userApi/v2/PassWord/changeByPhoneLogin',
  // 未登录时修改密码
  changeByPhone: '/userApi/v4/PassWord/changeByPhone'
};

export default passWord;
